var _rect, _path, _circle, _circle2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "url(#phantom-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16.5C24.5 21.194 20.694 25 16 25C11.306 25 7.5 21.194 7.5 16.5C7.5 11.806 11.306 8 16 8C20.694 8 24.5 11.806 24.5 16.5Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 15,
    r: 1.5,
    fill: "#AB9FF2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 1.5,
    fill: "#AB9FF2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phantom-gradient",
    x1: 0,
    y1: 0,
    x2: 32,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#534BB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#551BF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.51be3daf3209bbe4d7bde0d285a5eb58.svg";
export { ForwardRef as ReactComponent };